// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__208KF","visible":"styles_visible__2Yvjw","closeButton":"styles_closeButton__jBcYT","backButton":"styles_backButton__ZYGEf"};